import { render, staticRenderFns } from "./ViewFormRFSusar.vue?vue&type=template&id=6ef5c94c&scoped=true"
import script from "./ViewFormRFSusar.vue?vue&type=script&lang=js"
export * from "./ViewFormRFSusar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef5c94c",
  null
  
)

export default component.exports